// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class UByteValue implements flatbuffers.IUnpackableObject<UByteValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): UByteValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsUByteValue(bb: flatbuffers.ByteBuffer, obj?: UByteValue): UByteValue {
    return (obj || new UByteValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsUByteValue(bb: flatbuffers.ByteBuffer, obj?: UByteValue): UByteValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new UByteValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startUByteValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt8(0, value, 0);
  }

  static endUByteValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createUByteValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    UByteValue.startUByteValue(builder);
    UByteValue.addValue(builder, value);
    return UByteValue.endUByteValue(builder);
  }

  unpack(): UByteValueT {
    return new UByteValueT(this.value());
  }

  unpackTo(_o: UByteValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): UByteValueT {
    const t = new UByteValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class UByteValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return UByteValue.createUByteValue(builder, this.value);
  }

  clone(): UByteValueT {
    const obj = new UByteValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: UByteValueT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyUByteValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
